import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - fix!!!
import GetOutgoingPostbacksResponse = App.Http.Responses.Tracking.GetOutgoingPostbacksRequest;
import GetOutgoingPostbackResponse = App.Http.Responses.Tracking.GetOutgoingPostbackResponse;
import StoreOutgoingPostbackRequest = App.Http.Requests.Tracking.StoreOutgoingPostbackRequest;
import GetOutgoingPostbacksRequest = App.Http.Requests.Tracking.GetOutgoingPostbacksRequest;
// import GetOutgoingPostbackRequest = App.Http.Requests.Tracking.GetOutgoingPostbackRequest;
import GetConnectionSequenceStepsExportResponse = App.Http.Responses.ConnectionCreator.SequenceStep.GetConnectionSequenceStepsExportResponse;
import UpdateOutgoingPostbackRequest = App.Http.Requests.Tracking.UpdateOutgoingPostbackRequest;
import StoreOutgoingPostbackConnectionSequenceStepsRequest = App.Http.Requests.Tracking.StoreOutgoingPostbackConnectionSequenceStepsRequest;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;
import ExportResponse = App.Http.Responses.ExportResponse;
import TestOutgoingPostbackRequest = App.Http.Requests.Tracking.TestOutgoingPostbackRequest;
import TestConnectionSequenceStepResponse = App.Http.Responses.ConnectionSequenceStep.TestConnectionSequenceStepResponse;

class OutgoingPostbackApi extends TenantBaseApi {
    async index(request: GetOutgoingPostbacksRequest): Promise<GetOutgoingPostbacksResponse> {
        return await this.get<GetOutgoingPostbacksResponse, GetOutgoingPostbacksRequest>("/outgoing-postbacks", {
            params: request,
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async show(outgoingPostbackId: string, request: any): Promise<GetOutgoingPostbackResponse> {
        return await this.get<GetOutgoingPostbackResponse, unknown>(`/outgoing-postbacks/${outgoingPostbackId}`, {
            params: request,
        });
    }

    async store(request: StoreOutgoingPostbackRequest): Promise<GetOutgoingPostbackResponse> {
        return await this.post<GetOutgoingPostbackResponse, StoreOutgoingPostbackRequest>(
            "/outgoing-postbacks",
            request
        );
    }

    async update(
        request: UpdateOutgoingPostbackRequest,
        outgoingPostbackId: string
    ): Promise<GetOutgoingPostbackResponse> {
        return await this.patch<GetOutgoingPostbackResponse, UpdateOutgoingPostbackRequest>(
            `/outgoing-postbacks/${outgoingPostbackId}`,
            request
        );
    }

    async destroy(outgoingPostbackId: string): Promise<void> {
        return await this.delete<void>(`/outgoing-postbacks/${outgoingPostbackId}`);
    }

    /**
     * Get specific outgoing postback in export format
     *
     * - Request: { id: string }
     * - Response: GetOutgoingPostbackResponse
     */
    async showExport(
        outgoingPostbackId: string,
        request?: GetOutgoingPostbacksRequest
    ): Promise<GetOutgoingPostbackResponse> {
        return await this.get<GetOutgoingPostbackResponse, GetOutgoingPostbacksRequest>(
            `/outgoing-postbacks/${outgoingPostbackId}/export`,
            {
                params: request,
            }
        );
    }

    /**
     * Get specific outgoing postback connection sequence steps in export format
     *
     * - Request: { id: string }
     * - Response: GetOutgoingPostbackExportResponse
     */
    async showMethodsExport(
        outgoingPostbackId: string,
        request?: GetOutgoingPostbacksRequest
    ): Promise<GetConnectionSequenceStepsExportResponse> {
        return await this.get<GetConnectionSequenceStepsExportResponse, GetOutgoingPostbacksRequest>(
            `/outgoing-postbacks/${outgoingPostbackId}/connection-sequence-steps/export`,
            {
                params: request,
            }
        );
    }

    /**
     * Update OutgoingPostback methods (PUT)
     *
     * - Request: StoreOutgoingPostbackConnectionSequenceStepsRequest
     * - Response: StoreOutgoingPostbackConnectionSequenceStepsRequest
     */
    async updateMethods(
        request: StoreOutgoingPostbackConnectionSequenceStepsRequest,
        outgoingPostbackId: string
    ): Promise<GetConnectionSequenceStepsExportResponse> {
        return await this.put<
            GetConnectionSequenceStepsExportResponse,
            StoreOutgoingPostbackConnectionSequenceStepsRequest
        >(`/outgoing-postbacks/${outgoingPostbackId}/connection-sequence-steps`, request);
    }

    async export(request: BaseExportRequest): Promise<ExportResponse> {
        return await this.post<ExportResponse, BaseExportRequest>("/outgoing-postbacks/export", request);
    }

    async test(outgoingPostbackId: string, request: TestOutgoingPostbackRequest): Promise<TestConnectionSequenceStepResponse> {
        return await this.post<TestConnectionSequenceStepResponse, TestOutgoingPostbackRequest>(
            `/outgoing-postbacks/${outgoingPostbackId}/test`,
            request
        );
    }
}

export const outgoingPostbackApi = new OutgoingPostbackApi();
